<template>
    <div id="contenu">
      <div id='centre'>
        <component :is="layout">
        </component>
      </div>
    </div>
  </template>
  <script>
  export default {
      props: {
      },
    data() {
      return {
        post: {},
      }
    },
    mounted:function(){
    },
    methods: {
    },
    components: {
    },
    computed:{
      layout(){
        return(this.$route.meta.layout)+'-layout';
      }
    }
    
  }
  </script>
  <style>
  #centre{
      flex: 1 0 98%;
      transition: all .3s;
      position: absolute;
      top: 6%;
      left: 0;
      right: 0;
      bottom: 0;
      max-height: 94%;
      overflow: auto;
  }
  
  .v-sidebar-menu-client .collapse-btn{
      background-color:transparent;
      outline:none;
  }
  
  .v-sidebar-menu-client .vsm-item.first-item.active-item>.vsm-link>.vsm-icon, .v-sidebar-menu-client .vsm-item.first-item>.vsm-link>.vsm-icon{
      background-color:transparent;
  }
  
  .v-sidebar-menu-client{
      max-width: 12vw;
      background-color:#808285;
      position: absolute;
      height: 94%;
      top: 6%;
  }
  
  .v-sidebar-menu-client div:nth-child(2){
      max-width: 12vw;
  }
  
  .v-sidebar-menu-client .vsm-link{
      font-size:13px;
  }
  
  #contenu{
      display: flex;
      height: 100%;
      flex-wrap: wrap;
  }
  </style>